const _timeout = 600000

/**
 * 错误提示语字典
 * message {string} 提示框中的提示语
 * install {Boolean} 是否需要提示安装签章软件
 */
const errDict = {
  abnormal: {
    message:
      '<p>请求异常，请稍后重试</p><p style="font-size: 12px">若多次重试失败，请卸载签章中心，并重新打开本软件重新安装</p>'
  },
  timeout: {
    message:
      '<p>请求异常，请稍后重试</p><p style="font-size: 12px">若多次重试失败，请卸载签章中心，并重新打开本软件重新安装</p>'
  },
  // timeout: { message: '请求签章服务超时, 请稍后重试' },
  error: {
    message: '系统未检测到 签章中心和证书助手，无法进行签章操作，请先安装。',
    install: true
  }
}

/**
 * ajax请求封装函数
 * @param method
 * @param url
 * @param ctrl
 * @returns {XMLHttpRequest}
 */
function createCORSRequest(method, url, ctrl) {
  let xhr = new XMLHttpRequest()
  if ('withCredentials' in xhr) {
    xhr.open(method, url, true)
  } else if (typeof XDomainRequest != 'undefined') {
    // eslint-disable-next-line no-undef
    xhr = new XDomainRequest()
    xhr.open(method, url)
  } else {
    xhr = null
  }
  return xhr
}

export default class KgXhrClass {
  constructor(progid, inter, usercode) {
    this.url = 'https://local.kinggrid.com:9582'
    this.progid = progid
    this.inter = inter
    this.caller = 0
    this.time = _timeout
    this.usercode = usercode
  }

  init() {
    const val = JSON.stringify({
      GetInterface: { progid: this.progid, interface: this.inter },
      usercode: this.usercode
    })

    return new Promise((resolve, reject) => {
      const self = this

      const xhr = createCORSRequest('POST', this.url + '/GetInterface', this)
      xhr.timeout = this.time
      xhr.onload = function(e) {
        if (this.status != undefined) {
          if (this.status != 200 && this.status != 304) {
            return reject(errDict.abnormal)
          }
        }
        // eslint-disable-next-line no-eval
        var obj = eval('(' + this.responseText + ')')
        if (obj.value == 0 || obj.value === 'none') {
          return reject({ message: '签章服务初始化失败, 请稍后重试' })
        }
        self.caller = obj.value
        resolve()
      }

      xhr.ontimeout = () => {
        reject(errDict.timeout)
      }

      xhr.onerror = () => {
        reject(errDict.error)
      }

      xhr.send('value=' + val)
    })
  }

  /**
   * 调用金格服务功能
   * @param method {string} 对应的金格服务字符串标识
   */
  invoke(method) {
    // 设置参数
    const params = []
    if (arguments.length >= 2) {
      for (var i = 1; i < arguments.length; i++) {
        const typeVal = typeof arguments[i]
        const val = arguments[i] != null ? arguments[i].toString() : 'null'
        let data = null
        if (typeVal === 'boolean') {
          data = { type: 'BOOL', value: val }
        } else if (typeVal === 'number') {
          data = { type: 'LONG', value: val }
        } else {
          data = { type: 'BSTR', value: val }
        }
        params.push(data)
      }
    }

    const val = JSON.stringify({
      MethodCall: { caller: this.caller, function: method, params: params },
      usercode: this.usercode
    })

    return new Promise((resolve, reject) => {
      const xhr = createCORSRequest('POST', this.url + '/MethodCall', this)
      xhr.timeout = this.time

      xhr.onload = function(e) {
        if (this.status != undefined) {
          if (this.status != 200 && this.status != 304) {
            return reject(errDict.abnormal)
          }
        }

        var vRes = this.responseText.replace(/\\\\/g, '\\')
        // eslint-disable-next-line no-eval
        var obj = eval('(' + vRes + ')')
        resolve(obj.value)
      }

      xhr.ontimeout = e => {
        reject(errDict.timeout)
      }

      xhr.onerror = () => {
        reject(errDict.error)
      }

      xhr.send('value=' + val)
    })
  }

  get(property) {
    const val = JSON.stringify({
      PropertyCall: { caller: this.caller, property: property },
      usercode: this.usercode
    })

    return new Promise((resolve, reject) => {
      const xhr = createCORSRequest('POST', this.url + '/PropCall', this)
      xhr.timeout = this.time

      xhr.onload = function(e) {
        if (this.status != undefined) {
          if (this.status != 200 && this.status != 304) {
            return reject(errDict.abnormal)
          }
        }
        var temp = this.responseText.replace(/\n/g, '\\n').replace(/\r/g, '\\r')
        // eslint-disable-next-line no-eval
        const obj = eval('(' + temp + ')')
        resolve(obj.value)
      }

      xhr.ontimeout = e => {
        reject(errDict.timeout)
      }

      xhr.onerror = e => {
        reject(errDict.error)
      }

      xhr.send('value=' + val)
    })
  }

  put(property, value) {
    const typeVal = typeof value
    const _value = value != undefined ? value.toString() : 'null'
    let data = null

    if (typeVal === 'boolean') {
      data = { type: 'BOOL', value: _value }
    } else if (typeVal === 'number') {
      data = { type: 'LONG', value: _value }
    } else {
      data = { type: 'BSTR', value: _value }
    }

    const val = JSON.stringify({
      PropertyCallPut: {
        caller: self.caller,
        property: property,
        params: [data]
      },
      usercode: this.usercode
    })

    return new Promise((resolve, reject) => {
      const xhr = createCORSRequest('POST', this.url + '/PropCall', this)
      xhr.timeout = this.time

      xhr.onload = function(e) {
        if (this.status == 200 && this.status == 304) {
          // eslint-disable-next-line no-eval
          const obj = eval('(' + this.responseText + ')')
          resolve(obj.value)
        } else {
          reject(errDict.abnormal)
        }
      }

      xhr.ontimeout = e => {
        reject(errDict.timeout)
      }

      xhr.onerror = () => {
        reject(errDict.error)
      }

      xhr.send('value=' + val)
    })
  }

  setUrl(url) {
    this.url = url
  }
}
